// src/config/assets.js
//
// One place that decides where marketing media comes from.
//
// Every landing/marketing asset used to be a hardcoded
// `https://kolagentimages.s3.us-east-2.amazonaws.com/...` string — 22 of
// them across 4 files. That made the CDN cutover a 22-file edit and the
// rollback another one, which is the kind of change nobody wants to make
// under load. `assetUrl('hero-new_sm.mp4')` moves the decision to a single
// build-time env var.
//
// ── Why a CDN at all ────────────────────────────────────────────────────
// Raw S3 serves these from us-east-2 (Ohio) over HTTP/1.1 with NO
// Cache-Control header, and all three consequences are measurable:
//
//   · Distance. Every byte travels from Ohio to the visitor, every time.
//   · Connection cap. Browsers open ~6 connections per HTTP/1.1 origin, so
//     21 objects queue six at a time and the hero video competes with
//     decorative media for a slot.
//   · No caching. Measured in Chromium: one visitor hovering the request
//     cards (6 remounts over 3 distinct files) cost 7 server hits with no
//     Cache-Control and 3 with `public, max-age=31536000, immutable`. The
//     repeat downloads are not a React bug — the hover remount is free the
//     moment the response is cacheable.
//
// CloudFront in front of the same bucket fixes all three at once: edge
// locations for distance, HTTP/2 multiplexing for the connection cap, and
// a response-headers policy for the caching.
//
// ── Cutover ─────────────────────────────────────────────────────────────
// Default is the S3 origin, so an unset variable behaves exactly as today
// and a fresh clone or preview deploy keeps working. Point it at the
// distribution when that is live:
//
//     REACT_APP_ASSET_BASE=https://dXXXXXXXXXXXX.cloudfront.net
//
// Rollback is unsetting it and redeploying. See docs/cdn-runbook.md.
//
// CRA inlines REACT_APP_* at build time, so this costs nothing at runtime
// and there is no flash of the wrong host.
const DEFAULT_ORIGIN = 'https://kolagentimages.s3.us-east-2.amazonaws.com';

// Trailing slash trimmed so callers may write the base either way.
const BASE = String(process.env.REACT_APP_ASSET_BASE || DEFAULT_ORIGIN)
  .replace(/\/+$/, '');

/** Absolute URL for a marketing asset, by its key on the bucket.
 *  `assetUrl('models/ZeyaMaren.jpeg')` — no leading slash needed. */
export const assetUrl = (key) => `${BASE}/${String(key).replace(/^\/+/, '')}`;

/** The host actually in use — for the runbook's verification step. */
export const ASSET_BASE = BASE;

export default assetUrl;
